export class intial_api
{
    has_patient_active_med : any;
    last_icds_and_labs : any;
    patient_account : any;
    patient_dob : any;
    patient_gender : any;
    patient_rov : any;
    practice_code : any;
    provider_code : any;
    will_intake_form_show : any;
    dos: any;
}
export class selectedParts
{
    id:any;
    name:any;
    main:any;
    side:any;
}
export class symptomsAgainstBodyParts
{
    main:any;
    key:any;
    name:any;
    side:any;
}
export class SelectSymptomsAgainstPart
{
    key:any;
    name:any;
    side:any;
}
export class InitialSymptomsRequest
{
    anatomical_selected : anatomical_selected= new anatomical_selected;
    answer : any;
    patient_account : any;
}
export class anatomical_selected
{

}
export class General
{
    General:any=[];
}
export class Psychiatric
{
    Psychiatric:any=[];
}
export class abdomen
{
    abdomen : any = [];
    skin : any = [];
}
export class arm {
    arm: any = [];
    elbow: any = [];
    forearm: any = [];
    joints: any = [];
    shoulder: any = [];
    skin: any = [];
    ['upper arm']: any = [];
}
export class back
{
    back: any = [];
    skin: any = [];
}
export class head
{
    ear: any = [];
    eye: any = [];
    face: any = [];
    head: any = [];
    mouth: any = [];
    nose: any = [];
    skin: any = [];
}

export class chest{
    chest: any = [];
    skin: any = []
}
export class foot {
    ['ankle joint']: any = [];
    fingers: any = [];
    foot: any = [];
    skin: any = [];
    toe: any = []
}

export class genitals {
    genitourinary: any = [];
    skin: any = []
}
export class hands{
    fingers: any = [];
    hand: any = [];
    joints: any = [];
    skin: any = [];
    wrist: any = []
}
export class hip {
    hip: any = [];
    joints: any = [];
    skin: any = []
}
export class leg{
    calf: any = [];
    hip: any = [];
    knee: any = [];
    thigh: any = []
}
export class neck{
    neck: any = [];
    skin: any = [];
}
export class SendQuestionAns
{
    answer : any = new answer;
    patient_account:any;
}
export class answer
{

}
export class symptom
{
    value : any="";
}
export class AnsSingleValue
{
    value : any;
}
export class AnsDoubleValue
{
    key : any;
    value : any;
    drop_down : any;
}
export class CreateICDRequest
{
    request : any[] = [];
}
export class requestICD
{
    ICDS: any;
    SUMMARY: any;
    DOB: any;
    DOS: any;
    PROVIDER_CODE: any;
    PRACTICE_CODE: any;
    TRANSACTION_ID: any;
    PATIENT_ACCOUNT: any;
    CREATED_DATE: any;
    MODIFIED_DATE: any;
    DELETED: any;
    R_CODES: any;
    DIP_HTML: any;
    RISK_HTML: any;
    SYM_TO_ROS: any;
    ROS_CAT_WITH_SYM : any[] = [];
}
export class RosWithsymtoms
{
    symptoms : any[]=[]
    category_subCategory : any;
}
